import { createTitle } from "@bitcart/vike-kit/metadata"

export default createTitle()
